class _LocalStorageService {
    public KeyHomeCalendarView = 'homeCalendarView';
}

export const LocalStorageService = new _LocalStorageService();